import axios from 'axios';

import { toast } from '@/components/toast';
import { uploadConsent } from '@/pages/avatar/api';
import { CreateAvatarStoreUnion, RequestStatus } from '@/pages/avatar/common/types';
import { uploadFile } from '@/services/api';
import { logger } from '@/services/logger';

export enum ConsentValidationErrors {
    ConsentTextSimilarityError = 'ConsentTextSimilarityError',
    UploadError = 'UploadError',
    GeneralError = 'GeneralError',
}

export const ErrorMessages = {
    [ConsentValidationErrors.ConsentTextSimilarityError]:
        'The text read did not match the script given. \nPlease read directly from the script.',
    [ConsentValidationErrors.UploadError]: 'Failed to upload consent, please try again',
    [ConsentValidationErrors.GeneralError]: 'Failed to validate consent, please try again',
};

export const validateConsent = async (createAvatarStore: CreateAvatarStoreUnion) => {
    let url: string;
    createAvatarStore.setConsentValidationStatus(RequestStatus.LOADING);
    try {
        url = await uploadFile(createAvatarStore.consentFile!, createAvatarStore.consentAbortController?.signal, { s3Uri: true });
        createAvatarStore.setConsentFileSrc(url);
    } catch (error) {
        if (axios.isCancel(error)) {
            return;
        }

        logger.error('Failed to upload consent', error);
        const errorMessage = ErrorMessages[ConsentValidationErrors.UploadError];
        createAvatarStore.setConsentError(errorMessage);
        toast.error({ title: errorMessage });
        return;
    }

    try {
        await uploadConsent(
            createAvatarStore.uploadedConsentId,
            url,
            createAvatarStore.username,
            createAvatarStore.consentAbortController?.signal
        );
    } catch (error) {
        if (axios.isCancel(error)) {
            return;
        }

        logger.error('Failed to validate consent', error);
        const errorMessage = ErrorMessages[ConsentValidationErrors.GeneralError];
        createAvatarStore.setConsentError(errorMessage);
        toast.error({ title: errorMessage });
    }
};
